import React from 'react';

export interface IconGooglePlayProps {
  className?: string;
  size?: number | string;
  color?: string;
  fill?: string;
  stroke?: string;
}

const IconGooglePlay: React.FC<IconGooglePlayProps> = ({ 
  className = '', 
  size = 24, 
  color = 'currentColor', 
  fill, 
  stroke 
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      color={color}
      fill={fill || 'none'}
    >
       <path d="M14.7022 11.1541L6.09327 2.50791L17.0465 8.80602L14.7022 11.1541ZM3.84646 2C3.33936 2.26568 3 2.75015 3 3.37918V20.6208C3 21.2499 3.33936 21.7343 3.84646 22L13.8557 11.998L3.84646 2ZM20.4323 10.8142L18.1348 9.48193L15.572 12.002L18.1348 14.522L20.4791 13.1897C21.1812 12.631 21.1812 11.3729 20.4323 10.8142ZM6.09327 21.496L17.0465 15.1979L14.7022 12.8498L6.09327 21.496Z" fill={fill || "#020617"} />  
    </svg>
  );
};

export default IconGooglePlay;
